<template>
  <div class="gallery-page">
    <header class="page-head">
      <div class="container">
        <h1 class="page-head__title">Galeria</h1>
        <p class="page-head__lead">
          Nossos eventos, confraternizações e os melhores momentos estão registrados aqui.
        </p>
      </div>
    </header>

    <div class="container gallery-page__body">
      <p v-if="gallerys.length === 0" class="gallery-page__status" role="status">
        Carregando álbuns…
      </p>

      <ul v-else class="gallery-page__grid">
        <li v-for="album in gallerys" :key="album.id">
          <button type="button" class="album" @click="openGallery(album.id)">
            <span class="album__frame">
              <img :src="album.url" :alt="album.title" class="album__image" loading="lazy" />
            </span>
            <span class="album__caption">
              <span class="album__title">{{ album.title }}</span>
              <time class="album__date">{{ album.date }}</time>
            </span>
          </button>
        </li>
      </ul>
    </div>

    <tinybox v-if="images.length > 0" @close="tinyboxClose" v-model="tinyboxIndex" loop :images="images" />
  </div>
</template>

<script>
import galleryService from '../../../../service/galleryService'

export default {
  name: "Gallery",
  metaInfo: {
    title: "SEEB | Galeria",
    meta: [
      { name: 'description', content: 'Nossos eventos, confraternizações e os melhores momentos estão registrados aqui.' }
    ]
  },
  methods: {
    openGallery(id) {
      galleryService.get({ id: id }).then(res => {
        this.images = res.data.map(img => ({
          src: img.path,
          thumbnail: '',
          caption: '',
          alt: ''
        }));
      });
    },
    getGallerys() {
      galleryService.get({}).then(res => {
        this.gallerys = res.data.map(gallery => ({
          id: gallery.id,
          title: gallery.title,
          category: gallery.category,
          date: new Date(gallery.created_at).toLocaleDateString("pt-BR"),
          url: gallery.path
        }));
      });
    },
    tinyboxClose() {
      this.images = [];
      this.tinyboxIndex = 0;
    },
  },
  mounted() {
    this.getGallerys();
  },
  components: {
    Tinybox: () => import("vue-tinybox"),
    Footer: () => import("@/layouts/web/commons/Footer.vue"),
  },
  data() {
    return {
      gallerys: [],
      images: [],
      tinyboxIndex: 0
    };
  }
};
</script>

<style lang="scss" scoped>
.gallery-page {
  padding-bottom: var(--section);

  &__body {
    padding-top: clamp(40px, 5vw, 64px);
  }

  &__status {
    color: var(--c-muted);
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 48px 32px;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  @media (max-width: 899px) {
    &__grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 559px) {
    &__grid {
      grid-template-columns: 1fr;
      gap: 36px;
    }
  }
}

.album {
  display: block;
  width: 100%;
  padding: 0;
  background: none;
  border: 0;
  color: inherit;
  text-align: left;
  cursor: pointer;

  &__frame {
    display: block;
    aspect-ratio: calc(4 / 3);
    border-radius: var(--radius);
    overflow: hidden;
    background: #e6e9ee;
  }

  &__image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 400ms var(--ease);
  }

  &__caption {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    margin-top: 14px;
  }

  &__title {
    font-family: var(--font-display);
    font-size: var(--fs-h4);
    line-height: 1.25;
    color: var(--c-navy);
    text-decoration: underline;
    text-decoration-color: transparent;
    text-underline-offset: 5px;
    transition: text-decoration-color 160ms var(--ease);
  }

  &__date {
    flex-shrink: 0;
    font-size: var(--fs-meta);
    color: var(--c-muted);
    font-variant-numeric: tabular-nums;
  }

  &:hover &__image {
    transform: scale(1.03);
  }

  &:hover &__title,
  &:focus-visible &__title {
    text-decoration-color: currentColor;
  }
}
</style>
